<template>
  <navbar-link
    :to="{ name: 'coaching.sessions' }"
    :link-active="linkActive"
    :class="[$style.wrapper, notificationsCount && $style.notificationBubble]"
    :data-highlight-count="(notificationsCount > 99 ? '99+' : notificationsCount) || null"
    data-testid="navbar-coaching"
    :title="$t('modules.application.navbar.coaching')"
  >
    <component :is="navbarRoutesMap['coaching.sessions'].icon" />
  </navbar-link>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { useEvent } from '@/composables/useEvent'
import useNavbarRoutes from '@/composables/useNavbarRoutes'
import { coachingSessionsCount, getCoachingSessionsCount, getPinsCount, pinsCount } from './useCoachingCounts'
import NavbarLink from './NavbarLink.vue'

const route = useRoute()
const linkActive = computed(() => ['quizzes', 'pins', 'coaching'].some((r) => route.name?.toString().startsWith(r)))
const { navbarRoutesMap } = useNavbarRoutes()

getPinsCount()
getCoachingSessionsCount()

// Timeout to account for read-replica delay
useEvent('refresh-pins-count', () => setTimeout(getPinsCount, 1000))
useEvent('refresh-coaching-sessions-count', () => setTimeout(getCoachingSessionsCount, 1000))

const notificationsCount = computed(() => pinsCount.value + coachingSessionsCount.value)
</script>

<style lang="scss" module>
@use '../styles/navbar.scss' as *;
.faded {
  color: var(--gray-50);
  pointer-events: none;

  svg {
    color: var(--gray-40);
  }
}

.disableClickEvents {
  pointer-events: none;
}
</style>
